import { without } from 'lodash';

import { ACTION_TYPES as REPORTS_ACTION_TYPES } from '../../reports/constants';
import { ACTION_TYPES } from '../constants';

const defaultState = {};

const dashboardsEntitiesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACTION_TYPES.CREATE_DASHBOARD_SUCCESS:
      return {
        ...state,
        [action?.payload?._id]: action?.payload,
      };
    case ACTION_TYPES.GET_DASHBOARDS_BY_WORKSPACE_REQUEST: {
      return {};
    }
    case ACTION_TYPES.GET_DASHBOARDS_BY_WORKSPACE_SUCCESS: {
      return (action?.payload || []).reduce(
        (result, dashboardEntity) => ({
          ...result,
          [dashboardEntity?._id]: dashboardEntity,
        }),
        {},
      );
    }
    case ACTION_TYPES.GET_DASHBOARD_REQUEST: {
      const dashboardId = action?.payload?.dashboardId;
      return {
        ...state,
        [dashboardId]: {
          ...(state[dashboardId] || {}),
          loading: true,
        },
      };
    }
    case ACTION_TYPES.GET_DASHBOARD_SUCCESS: {
      const dashboardId = action?.payload?.result?.data;
      return {
        ...state,
        [dashboardId]: {
          ...(state[dashboardId] || {}),
          ...(action?.payload?.entities?.dashboards?.[dashboardId] || {}),
          loading: false,
        },
      };
    }
    case ACTION_TYPES.GET_DASHBOARD_FAILURE: {
      const dashboardId = action?.payload?.dashboardId;
      return {
        ...state,
        [dashboardId]: {
          ...(state[dashboardId] || {}),
          loading: false,
        },
      };
    }
    case ACTION_TYPES.DELETE_DASHBOARD_SUCCESS: {
      const { [action?.payload?.dashboardId]: _removed, ...rest } = state;
      return rest;
    }
    case ACTION_TYPES.UPDATE_DASHBOARD_SUCCESS: {
      const dashboardId = action?.payload?._id;
      return {
        ...state,
        [dashboardId]: {
          ...(state[dashboardId] || {}),
          ...(action?.payload || {}),
        },
      };
    }
    case REPORTS_ACTION_TYPES.DELETE_REPORT_SUCCESS: {
      const dashboardId = action?.payload?.dashboardId;
      return {
        ...state,
        [dashboardId]: {
          ...(state[dashboardId] || {}),
          reports: without(
            state[dashboardId]?.reports,
            action?.payload?.reportId,
          ),
        },
      };
    }
    case REPORTS_ACTION_TYPES.CREATE_REPORT_SUCCESS: {
      const dashboardId = action?.payload?.dashboard;
      return {
        ...state,
        [dashboardId]: {
          ...(state[dashboardId] || {}),
          reports: [
            ...(state[dashboardId]?.reports || []),
            action?.payload?._id,
          ],
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default dashboardsEntitiesReducer;
